<div
    class="py-4 container"
    data-testid="t-dummy-site-div-1752672977568-120"
>
    <style>
        h4 {
            margin-top: 2rem;
        }
    </style>

    <section data-testid="t-dummy-site-section-1752672977568-1">
        <h2 data-testid="t-dummy-site-h2-1752672977568-1">Element-Übersicht</h2>

        <h3 data-testid="t-dummy-site-h3-1752672977568-1">Modales Fenster (Markup)</h3>

        <div
            class="d-flex gap-3"
            data-testid="t-dummy-site-div-1752672977568-1"
        >
            <button
                class="btn btn-primary"
                data-oc-close-on-backdrop-click="false"
                data-oc-modal="#modalSm"
                data-testid="t-dummy-site-button-1752672977568-1"
            >
                Modal Small
            </button>
            <button
                class="btn btn-primary"
                data-oc-modal="#modalStandard"
                data-testid="t-dummy-site-button-1752672977568-2"
            >
                Modal Standard (ohne Fade)
            </button>
            <button
                class="btn btn-primary"
                data-oc-modal="#modalLg"
                data-testid="t-dummy-site-button-1752672977568-3"
            >
                Modal Large
            </button>
            <button
                class="btn btn-primary"
                data-oc-modal="#modalXl"
                data-testid="t-dummy-site-button-1752672977568-4"
            >
                Modal Extra Large
            </button>
        </div>

        <!-- Die Klassen "fade" sowie die Größen (modal-dialog) sollten übergebbar sein -->

        <div
            class="modal fade"
            tabindex="-1"
            id="modalSm"
            data-testid="t-dummy-site-div-1752672977568-7"
        >
            <div
                class="modal-dialog modal-sm"
                data-testid="t-dummy-site-div-1752672977568-6"
            >
                <div
                    class="modal-content"
                    data-testid="t-dummy-site-div-1752672977568-5"
                >
                    <div
                        class="modal-header"
                        data-testid="t-dummy-site-div-1752672977568-2"
                    >
                        <h5
                            class="modal-title"
                            data-testid="t-dummy-site-h5-1752672977568-1"
                        >
                            Modal-SM
                        </h5>
                        <button
                            type="button"
                            class="btn-close"
                            data-testid="t-dummy-site-button-1752672977568-5"
                        ></button>
                    </div>
                    <div
                        class="modal-body"
                        data-testid="t-dummy-site-div-1752672977568-3"
                    >
                        <p data-testid="t-dummy-site-p-1752672977568-1">
                            Dies ist ein kleines Modal-Fenster. Lässt sich nicht schließen, nach Klick auf Backdrop
                        </p>
                    </div>
                    <div
                        class="modal-footer"
                        data-testid="t-dummy-site-div-1752672977568-4"
                    >
                        <button
                            type="button"
                            class="btn btn-danger me-auto"
                            data-oc-dismiss="modal"
                            data-testid="t-dummy-site-button-1752672977568-6"
                        >
                            <i
                                class="oc-general-cancel"
                                data-testid="t-dummy-site-i-1752672977568-1"
                            ></i>
                        </button>
                        <button
                            type="button"
                            class="btn btn-success"
                            data-testid="t-dummy-site-button-1752672977568-7"
                        >
                            <i
                                class="oc-general-check"
                                data-testid="t-dummy-site-i-1752672977568-2"
                            ></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="modal"
            tabindex="-1"
            id="modalStandard"
            data-testid="t-dummy-site-div-1752672977568-13"
        >
            <div
                class="modal-dialog"
                data-testid="t-dummy-site-div-1752672977568-12"
            >
                <div
                    class="modal-content"
                    data-testid="t-dummy-site-div-1752672977568-11"
                >
                    <div
                        class="modal-header"
                        data-testid="t-dummy-site-div-1752672977568-8"
                    >
                        <h5
                            class="modal-title"
                            data-testid="t-dummy-site-h5-1752672977568-2"
                        >
                            Modal (Standard)
                        </h5>
                        <button
                            type="button"
                            class="btn-close"
                            data-testid="t-dummy-site-button-1752672977568-8"
                        ></button>
                    </div>
                    <div
                        class="modal-body"
                        data-testid="t-dummy-site-div-1752672977568-9"
                    >
                        <p data-testid="t-dummy-site-p-1752672977568-2">OHNE Fade Klasse</p>
                    </div>
                    <div
                        class="modal-footer"
                        data-testid="t-dummy-site-div-1752672977568-10"
                    >
                        <button
                            type="button"
                            class="btn btn-danger"
                            data-oc-dismiss="modal"
                            data-testid="t-dummy-site-button-1752672977568-9"
                        >
                            <i
                                class="oc-general-cancel"
                                data-testid="t-dummy-site-i-1752672977568-3"
                            ></i>
                        </button>
                        <button
                            type="button"
                            class="btn btn-success"
                            data-testid="t-dummy-site-button-1752672977568-10"
                        >
                            <i
                                class="oc-general-check"
                                data-testid="t-dummy-site-i-1752672977568-4"
                            ></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="modal fade"
            tabindex="-1"
            id="modalLg"
            data-testid="t-dummy-site-div-1752672977568-19"
        >
            <div
                class="modal-dialog modal-lg"
                data-testid="t-dummy-site-div-1752672977568-18"
            >
                <div
                    class="modal-content"
                    data-testid="t-dummy-site-div-1752672977568-17"
                >
                    <div
                        class="modal-header"
                        data-testid="t-dummy-site-div-1752672977568-14"
                    >
                        <h5
                            class="modal-title"
                            data-testid="t-dummy-site-h5-1752672977568-3"
                        >
                            Modal-LG
                        </h5>
                        <button
                            type="button"
                            class="btn-close"
                            data-testid="t-dummy-site-button-1752672977568-11"
                        ></button>
                    </div>
                    <div
                        class="modal-body"
                        data-testid="t-dummy-site-div-1752672977568-15"
                    >
                        <p data-testid="t-dummy-site-p-1752672977568-3">Dies ist ein großes Modal-Fenster.</p>
                    </div>
                    <div
                        class="modal-footer"
                        data-testid="t-dummy-site-div-1752672977568-16"
                    >
                        <button
                            type="button"
                            class="btn btn-danger"
                            data-oc-dismiss="modal"
                            data-testid="t-dummy-site-button-1752672977568-12"
                        >
                            <i
                                class="oc-general-cancel"
                                data-testid="t-dummy-site-i-1752672977568-5"
                            ></i>
                        </button>
                        <button
                            type="button"
                            class="btn btn-success"
                            data-testid="t-dummy-site-button-1752672977568-13"
                        >
                            <i
                                class="oc-general-check"
                                data-testid="t-dummy-site-i-1752672977568-6"
                            ></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="modal fade"
            tabindex="-1"
            id="modalXl"
            data-testid="t-dummy-site-div-1752672977568-25"
        >
            <div
                class="modal-dialog modal-xl"
                data-testid="t-dummy-site-div-1752672977568-24"
            >
                <div
                    class="modal-content"
                    data-testid="t-dummy-site-div-1752672977568-23"
                >
                    <div
                        class="modal-header"
                        data-testid="t-dummy-site-div-1752672977568-20"
                    >
                        <h5
                            class="modal-title"
                            data-testid="t-dummy-site-h5-1752672977568-4"
                        >
                            Modal-XL
                        </h5>
                        <button
                            type="button"
                            class="btn-close"
                            data-testid="t-dummy-site-button-1752672977568-14"
                        >
                            <i
                                class="oc-general-cancel"
                                data-testid="t-dummy-site-i-1752672977568-7"
                            ></i>
                        </button>
                    </div>
                    <div
                        class="modal-body"
                        data-testid="t-dummy-site-div-1752672977568-21"
                    >
                        <p data-testid="t-dummy-site-p-1752672977568-4">Dies ist ein extra großes Modal-Fenster.</p>
                    </div>
                    <div
                        class="modal-footer"
                        data-testid="t-dummy-site-div-1752672977568-22"
                    >
                        <button
                            type="button"
                            class="btn btn-danger"
                            data-oc-dismiss="modal"
                            data-testid="t-dummy-site-button-1752672977568-15"
                        >
                            <i
                                class="oc-general-cancel"
                                data-testid="t-dummy-site-i-1752672977568-8"
                            ></i>
                        </button>
                        <button
                            type="button"
                            class="btn btn-success"
                            data-testid="t-dummy-site-button-1752672977568-16"
                        >
                            <i
                                class="oc-general-check"
                                data-testid="t-dummy-site-i-1752672977568-9"
                            ></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <hr data-testid="t-dummy-site-hr-1752672977568-1" />

        <h3 data-testid="t-dummy-site-h3-1752672977568-2">Akkordeon-Markup</h3>
        <div
            class="accordion"
            data-testid="t-dummy-site-div-1752672977568-30"
        >
            <div
                class="accordion-item"
                data-oc-accordion
                data-testid="t-dummy-site-div-1752672977568-29"
            >
                <div
                    class="accordion-header"
                    data-testid="t-dummy-site-div-1752672977568-26"
                >
                    <button
                        class="accordion-button"
                        type="button"
                        data-testid="t-dummy-site-button-1752672977568-17"
                    >
                        Akkordeon-Beispiel 1
                    </button>
                </div>
                <div
                    class="accordion-collapse"
                    data-testid="t-dummy-site-div-1752672977568-28"
                >
                    <div
                        class="accordion-body"
                        data-testid="t-dummy-site-div-1752672977568-27"
                    >
                        Akkordeon-Inhalt 1 hier
                    </div>
                </div>
            </div>
        </div>
        <div
            class="accordion"
            data-testid="t-dummy-site-div-1752672977568-48"
        >
            <div
                class="accordion-item"
                data-oc-accordion
                data-testid="t-dummy-site-div-1752672977568-43"
            >
                <div
                    class="accordion-header"
                    data-testid="t-dummy-site-div-1752672977568-31"
                >
                    <button
                        class="accordion-button"
                        type="button"
                        data-testid="t-dummy-site-button-1752672977568-18"
                    >
                        Akkordeon-Beispiel 2
                    </button>
                </div>
                <div
                    class="accordion-collapse"
                    data-testid="t-dummy-site-div-1752672977568-42"
                >
                    <div
                        class="accordion-body"
                        data-testid="t-dummy-site-div-1752672977568-41"
                    >
                        <div
                            class="accordion"
                            data-testid="t-dummy-site-div-1752672977568-40"
                        >
                            <div
                                class="accordion-item"
                                data-oc-accordion
                                data-testid="t-dummy-site-div-1752672977568-35"
                            >
                                <div
                                    class="accordion-header"
                                    data-testid="t-dummy-site-div-1752672977568-32"
                                >
                                    <button
                                        class="accordion-button"
                                        type="button"
                                        data-testid="t-dummy-site-button-1752672977568-19"
                                    >
                                        Verschachteltes Akkordeon 1
                                    </button>
                                </div>
                                <div
                                    class="accordion-collapse"
                                    data-testid="t-dummy-site-div-1752672977568-34"
                                >
                                    <div
                                        class="accordion-body"
                                        data-testid="t-dummy-site-div-1752672977568-33"
                                    >
                                        Verschachtelter Inhalt 1 hier
                                    </div>
                                </div>
                            </div>
                            <div
                                class="accordion-item"
                                data-oc-accordion
                                data-testid="t-dummy-site-div-1752672977568-39"
                            >
                                <div
                                    class="accordion-header"
                                    data-testid="t-dummy-site-div-1752672977568-36"
                                >
                                    <button
                                        class="accordion-button"
                                        type="button"
                                        data-testid="t-dummy-site-button-1752672977568-20"
                                    >
                                        Verschachteltes Akkordeon 2
                                    </button>
                                </div>
                                <div
                                    class="accordion-collapse"
                                    data-testid="t-dummy-site-div-1752672977568-38"
                                >
                                    <div
                                        class="accordion-body"
                                        data-testid="t-dummy-site-div-1752672977568-37"
                                    >
                                        Verschachtelter Inhalt 2 hier
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="accordion-item"
                data-oc-accordion
                data-testid="t-dummy-site-div-1752672977568-47"
            >
                <div
                    class="accordion-header"
                    data-testid="t-dummy-site-div-1752672977568-44"
                >
                    <button
                        class="accordion-button"
                        type="button"
                        data-testid="t-dummy-site-button-1752672977568-21"
                    >
                        Akkordeon-Beispiel 3
                    </button>
                </div>
                <div
                    class="accordion-collapse"
                    data-testid="t-dummy-site-div-1752672977568-46"
                >
                    <div
                        class="accordion-body"
                        data-testid="t-dummy-site-div-1752672977568-45"
                    >
                        Akkordeon-Inhalt 3 hier
                    </div>
                </div>
            </div>
        </div>

        <hr data-testid="t-dummy-site-hr-1752672977568-2" />

        <h3 data-testid="t-dummy-site-h3-1752672977568-3">Generelle Styling-Klassen (Bootstrap)</h3>
        <ul data-testid="t-dummy-site-ul-1752672977568-1">
            <li data-testid="t-dummy-site-li-1752672977568-1">
                <a
                    target="_blank"
                    href="https://getbootstrap.com/docs/5.3/getting-started/introduction/"
                    data-testid="t-dummy-site-a-1752672977568-1"
                    >Bootstrap Dokumentation</a
                >
            </li>
        </ul>

        <h3 data-testid="t-dummy-site-h3-1752672977568-4">add--header</h3>
        <div
            class="add--header"
            data-testid="t-dummy-site-div-1752672977568-51"
        >
            <div
                class="col"
                data-testid="t-dummy-site-div-1752672977568-49"
            >
                <span
                    class="h5"
                    data-testid="t-dummy-site-span-1752672977568-1"
                    >Das ist die Überschrift</span
                >
            </div>
            <div
                class="col-auto text-end"
                data-testid="t-dummy-site-div-1752672977568-50"
            >
                <button
                    type="button"
                    class="btn btn-sm btn-primary action--btn"
                    data-testid="t-dummy-site-button-1752672977568-22"
                >
                    <i
                        class="oc-plus"
                        data-testid="t-dummy-site-i-1752672977568-10"
                    ></i>
                </button>
            </div>
        </div>

        <hr data-testid="t-dummy-site-hr-1752672977568-3" />

        <h3 data-testid="t-dummy-site-h3-1752672977568-5">Tabelle</h3>
        <div
            class="table-oc-responsive table-responsive"
            data-testid="t-dummy-site-div-1752672977568-52"
        >
            <table
                class="table"
                data-testid="t-dummy-site-table-1752672977568-1"
            >
                <thead data-testid="t-dummy-site-thead-1752672977568-1">
                    <tr data-testid="t-dummy-site-tr-1752672977568-1">
                        <th data-testid="t-dummy-site-th-1752672977568-1">Head</th>
                        <th data-testid="t-dummy-site-th-1752672977568-2">Head</th>
                    </tr>
                </thead>
                <tbody data-testid="t-dummy-site-tbody-1752672977568-1">
                    <tr data-testid="t-dummy-site-tr-1752672977568-2">
                        <td data-testid="t-dummy-site-td-1752672977568-1">Spalteninhalt</td>
                        <td data-testid="t-dummy-site-td-1752672977568-2">Spalteninhalt</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <h4 data-testid="t-dummy-site-h4-1752672977568-1">Verfügbare Klassen (table-wrapper):</h4>
        <ul data-testid="t-dummy-site-ul-1752672977568-2">
            <li data-testid="t-dummy-site-li-1752672977568-2">table-scrollable</li>
            <li data-testid="t-dummy-site-li-1752672977568-3">table-centered</li>
            <li data-testid="t-dummy-site-li-1752672977568-4">table-hover</li>
            <li data-testid="t-dummy-site-li-1752672977568-5">table-bordered</li>
            <li data-testid="t-dummy-site-li-1752672977568-6">table-light</li>
            <li data-testid="t-dummy-site-li-1752672977568-7">table-dark</li>
            <li data-testid="t-dummy-site-li-1752672977568-8">table-striped</li>
            <li data-testid="t-dummy-site-li-1752672977568-9">table-sm</li>
        </ul>

        <h4 data-testid="t-dummy-site-h4-1752672977568-2">Verfügbare Klassen (table):</h4>
        <ul data-testid="t-dummy-site-ul-1752672977568-3">
            <li data-testid="t-dummy-site-li-1752672977568-10">all-auto-width</li>
            <li data-testid="t-dummy-site-li-1752672977568-11">first-cell-auto-width</li>
            <li data-testid="t-dummy-site-li-1752672977568-12">article-list--table (requires: span.article-number and td.row-title</li>
        </ul>

        <h4 data-testid="t-dummy-site-h4-1752672977568-3">Verfügbare Klassen (th, td, tr)</h4>
        <ul data-testid="t-dummy-site-ul-1752672977568-4">
            <li data-testid="t-dummy-site-li-1752672977568-13">thead.fixed-head</li>
            <li data-testid="t-dummy-site-li-1752672977568-14">tr.table-oc-expanded-row</li>
            <li data-testid="t-dummy-site-li-1752672977568-15">td.is-sticky</li>
            <li data-testid="t-dummy-site-li-1752672977568-16">tr.selected, .tr.active</li>
            <li data-testid="t-dummy-site-li-1752672977568-17">td > div.expandable-cell</li>
            <li data-testid="t-dummy-site-li-1752672977568-18">tr.table-oc-expanded-row</li>
            <li data-testid="t-dummy-site-li-1752672977568-19">tr.disabled-row</li>
            <li data-testid="t-dummy-site-li-1752672977568-20">tr.hidden-row</li>
        </ul>
        <h3 data-testid="t-dummy-site-h3-1752672977568-6">Allgemeine Styling-Klassen</h3>
        <ul data-testid="t-dummy-site-ul-1752672977568-5">
            <li data-testid="t-dummy-site-li-1752672977568-21">no-box-shadow</li>
            <li data-testid="t-dummy-site-li-1752672977568-22">bottom-border-black</li>
            <li data-testid="t-dummy-site-li-1752672977568-23">text-lg</li>
            <li data-testid="t-dummy-site-li-1752672977568-24">fw-bolder</li>
            <li data-testid="t-dummy-site-li-1752672977568-25">is-clickable</li>
        </ul>

        <h3 data-testid="t-dummy-site-h3-1752672977568-7">Border-Klassen</h3>
        <ul data-testid="t-dummy-site-ul-1752672977568-6">
            <li data-testid="t-dummy-site-li-1752672977568-26">border-gray</li>
            <li data-testid="t-dummy-site-li-1752672977568-27">border</li>
            <li data-testid="t-dummy-site-li-1752672977568-28">br-50</li>
        </ul>

        <h3 data-testid="t-dummy-site-h3-1752672977568-8">Hintergrund-Farben</h3>
        <ul data-testid="t-dummy-site-ul-1752672977568-7">
            <li data-testid="t-dummy-site-li-1752672977568-29">bg-gray</li>
            <li data-testid="t-dummy-site-li-1752672977568-30">bg-gray-light</li>
            <li data-testid="t-dummy-site-li-1752672977568-31">bg-gray-lighter</li>
            <li data-testid="t-dummy-site-li-1752672977568-32">bg-gray-dark</li>
            <li data-testid="t-dummy-site-li-1752672977568-33">bg-gray-300</li>
            <li data-testid="t-dummy-site-li-1752672977568-34">bg-accent</li>
            <li data-testid="t-dummy-site-li-1752672977568-35">bg-warn</li>
        </ul>

        <h3 data-testid="t-dummy-site-h3-1752672977568-9">Flexibilität und Breite</h3>
        <ul data-testid="t-dummy-site-ul-1752672977568-8">
            <li data-testid="t-dummy-site-li-1752672977568-36">w-auto</li>
            <li data-testid="t-dummy-site-li-1752672977568-37">h-100</li>
            <li data-testid="t-dummy-site-li-1752672977568-38">w-100</li>
        </ul>

        <h3 data-testid="t-dummy-site-h3-1752672977568-10">Zustände</h3>
        <ul data-testid="t-dummy-site-ul-1752672977568-9">
            <li data-testid="t-dummy-site-li-1752672977568-39">disabled</li>
            <li data-testid="t-dummy-site-li-1752672977568-40">[disabled]</li>
            <li data-testid="t-dummy-site-li-1752672977568-41">[hidden]</li>
        </ul>

        <h3 data-testid="t-dummy-site-h3-1752672977568-11">Container und Layout</h3>
        <ul data-testid="t-dummy-site-ul-1752672977568-10">
            <li data-testid="t-dummy-site-li-1752672977568-42">centered-container</li>
            <li data-testid="t-dummy-site-li-1752672977568-43">disabled-block</li>
            <li data-testid="t-dummy-site-li-1752672977568-44">disabled-block.with-cursor</li>
            <li data-testid="t-dummy-site-li-1752672977568-45">cursor-pointer</li>
        </ul>

        <h3 data-testid="t-dummy-site-h3-1752672977568-12">Zeilenabstand</h3>
        <ul data-testid="t-dummy-site-ul-1752672977568-11">
            <li data-testid="t-dummy-site-li-1752672977568-46">lh-auto</li>
        </ul>

        <h3 data-testid="t-dummy-site-h3-1752672977568-13">Scrolling</h3>
        <ul data-testid="t-dummy-site-ul-1752672977568-12">
            <li data-testid="t-dummy-site-li-1752672977568-47">scrolling-x</li>
        </ul>

        <h3 data-testid="t-dummy-site-h3-1752672977568-14">Hintergrundbild</h3>
        <ul data-testid="t-dummy-site-ul-1752672977568-13">
            <li data-testid="t-dummy-site-li-1752672977568-48">ui-bg-cover</li>
        </ul>

        <h3 data-testid="t-dummy-site-h3-1752672977568-15">Text-Ausrichtung</h3>
        <ul data-testid="t-dummy-site-ul-1752672977568-14">
            <li data-testid="t-dummy-site-li-1752672977568-49">text-end + .text-start</li>
        </ul>

        <h3 data-testid="t-dummy-site-h3-1752672977568-16">Flex-Layout</h3>
        <ul data-testid="t-dummy-site-ul-1752672977568-15">
            <li data-testid="t-dummy-site-li-1752672977568-50">d-flex</li>
        </ul>

        <h3 data-testid="t-dummy-site-h3-1752672977568-17">Content-Box</h3>

        <div
            class="row"
            data-testid="t-dummy-site-div-1752672977568-59"
        >
            <div
                class="col-md-4"
                data-testid="t-dummy-site-div-1752672977568-54"
            >
                <div
                    class="content-box"
                    data-testid="t-dummy-site-div-1752672977568-53"
                >
                    Content-Box
                </div>
            </div>
            <div
                class="col-md-4"
                data-testid="t-dummy-site-div-1752672977568-56"
            >
                <div
                    class="content-box small-padding"
                    data-testid="t-dummy-site-div-1752672977568-55"
                >
                    Content-Box small-padding
                </div>
            </div>
            <div
                class="col-md-4"
                data-testid="t-dummy-site-div-1752672977568-58"
            >
                <div
                    class="content-box flexible-height"
                    data-testid="t-dummy-site-div-1752672977568-57"
                >
                    Content-box flexible-height
                </div>
            </div>
        </div>

        <h3 data-testid="t-dummy-site-h3-1752672977568-18">Buttons (OC)</h3>

        <div
            style="display: grid; grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); gap: 20px"
            data-testid="t-dummy-site-div-1752672977568-68"
        >
            <div data-testid="t-dummy-site-div-1752672977568-60">
                <h3 data-testid="t-dummy-site-h3-1752672977568-19">Primary Variants</h3>
                <button
                    class="btn btn-primary"
                    data-testid="t-dummy-site-button-1752672977568-23"
                >
                    Primary
                </button>
                <button
                    class="btn btn-primary-light"
                    data-testid="t-dummy-site-button-1752672977568-24"
                >
                    Primary Light
                </button>
                <button
                    class="btn btn-primary-lighter"
                    data-testid="t-dummy-site-button-1752672977568-25"
                >
                    Primary Lighter
                </button>
                <button
                    class="btn btn-primary-lightest"
                    data-testid="t-dummy-site-button-1752672977568-26"
                >
                    Primary Lightest
                </button>
                <button
                    class="btn btn-primary-dark"
                    data-testid="t-dummy-site-button-1752672977568-27"
                >
                    Primary Dark
                </button>
                <button
                    class="btn btn-primary-darker"
                    data-testid="t-dummy-site-button-1752672977568-28"
                >
                    Primary Darker
                </button>
            </div>

            <div data-testid="t-dummy-site-div-1752672977568-61">
                <h3 data-testid="t-dummy-site-h3-1752672977568-20">Secondary Variants</h3>
                <button
                    class="btn btn-secondary"
                    data-testid="t-dummy-site-button-1752672977568-29"
                >
                    Secondary
                </button>
                <button
                    class="btn btn-secondary-light"
                    data-testid="t-dummy-site-button-1752672977568-30"
                >
                    Secondary Light
                </button>
                <button
                    class="btn btn-secondary-lighter"
                    data-testid="t-dummy-site-button-1752672977568-31"
                >
                    Secondary Lighter
                </button>
                <button
                    class="btn btn-secondary-lightest"
                    data-testid="t-dummy-site-button-1752672977568-32"
                >
                    Secondary Lightest
                </button>
                <button
                    class="btn btn-secondary-dark"
                    data-testid="t-dummy-site-button-1752672977568-33"
                >
                    Secondary Dark
                </button>
            </div>

            <div data-testid="t-dummy-site-div-1752672977568-62">
                <h3 data-testid="t-dummy-site-h3-1752672977568-21">Other Theme Colors</h3>
                <button
                    class="btn btn-success"
                    data-testid="t-dummy-site-button-1752672977568-34"
                >
                    Success
                </button>
                <button
                    class="btn btn-info"
                    data-testid="t-dummy-site-button-1752672977568-35"
                >
                    Info
                </button>
                <button
                    class="btn btn-warning"
                    data-testid="t-dummy-site-button-1752672977568-36"
                >
                    Warning
                </button>
                <button
                    class="btn btn-danger"
                    data-testid="t-dummy-site-button-1752672977568-37"
                >
                    Danger
                </button>
                <button
                    class="btn btn-light"
                    data-testid="t-dummy-site-button-1752672977568-38"
                >
                    Light
                </button>
                <button
                    class="btn btn-dark"
                    data-testid="t-dummy-site-button-1752672977568-39"
                >
                    Dark
                </button>
            </div>

            <div data-testid="t-dummy-site-div-1752672977568-63">
                <h3 data-testid="t-dummy-site-h3-1752672977568-22">Outline Buttons</h3>
                <button
                    class="btn btn-outline-primary"
                    data-testid="t-dummy-site-button-1752672977568-40"
                >
                    Primary
                </button>
                <button
                    class="btn btn-outline-secondary"
                    data-testid="t-dummy-site-button-1752672977568-41"
                >
                    Secondary
                </button>
                <button
                    class="btn btn-outline-success"
                    data-testid="t-dummy-site-button-1752672977568-42"
                >
                    Success
                </button>
                <button
                    class="btn btn-outline-danger"
                    data-testid="t-dummy-site-button-1752672977568-43"
                >
                    Danger
                </button>
                <button
                    class="btn btn-outline-warning"
                    data-testid="t-dummy-site-button-1752672977568-44"
                >
                    Warning
                </button>
                <button
                    class="btn btn-outline-info"
                    data-testid="t-dummy-site-button-1752672977568-45"
                >
                    Info
                </button>
                <button
                    class="btn btn-outline-light"
                    data-testid="t-dummy-site-button-1752672977568-46"
                >
                    Light
                </button>
                <button
                    class="btn btn-outline-dark"
                    data-testid="t-dummy-site-button-1752672977568-47"
                >
                    Dark
                </button>
            </div>

            <div data-testid="t-dummy-site-div-1752672977568-64">
                <h3 data-testid="t-dummy-site-h3-1752672977568-23">Size Variants</h3>
                <button
                    class="btn btn-primary btn-sm"
                    data-testid="t-dummy-site-button-1752672977568-48"
                >
                    Small
                </button>
                <button
                    class="btn btn-primary"
                    data-testid="t-dummy-site-button-1752672977568-49"
                >
                    Default
                </button>
                <button
                    class="btn btn-primary btn-lg"
                    data-testid="t-dummy-site-button-1752672977568-50"
                >
                    Large
                </button>
            </div>

            <div data-testid="t-dummy-site-div-1752672977568-65">
                <h3 data-testid="t-dummy-site-h3-1752672977568-24">Special Variants</h3>
                <button
                    class="btn btn-link"
                    data-testid="t-dummy-site-button-1752672977568-51"
                >
                    Link
                </button>
                <button
                    class="btn btn-transparent"
                    data-testid="t-dummy-site-button-1752672977568-52"
                >
                    Transparent
                </button>
            </div>

            <div data-testid="t-dummy-site-div-1752672977568-66">
                <h3 data-testid="t-dummy-site-h3-1752672977568-25">Functional Variants</h3>
                <button
                    class="btn btn-primary with-badge"
                    data-testid="t-dummy-site-button-1752672977568-53"
                >
                    With Badge
                    <span
                        class="badge bg-secondary"
                        data-testid="t-dummy-site-span-1752672977568-2"
                        >4</span
                    >
                </button>
                <button
                    class="btn btn-primary image-btn"
                    data-testid="t-dummy-site-button-1752672977568-54"
                >
                    <img
                        loading="lazy"
                        src="/assets/img/logo_orgacard_mobile.svg"
                        alt="OrgaCard Logo"
                        data-testid="t-dummy-site-img-1752672977568-1"
                    />
                    Image Button
                </button>
                <button
                    class="btn btn-primary"
                    data-testid="t-dummy-site-button-1752672977568-55"
                >
                    <i
                        class="oc-general-check"
                        data-testid="t-dummy-site-i-1752672977568-11"
                    ></i>
                </button>
                <button
                    class="btn btn-primary with-icon"
                    data-testid="t-dummy-site-button-1752672977568-56"
                >
                    <i
                        class="oc-general-check"
                        data-testid="t-dummy-site-i-1752672977568-12"
                    ></i>
                    With Icon
                </button>
                <button
                    class="btn btn-primary btn-filter"
                    data-testid="t-dummy-site-button-1752672977568-57"
                >
                    Filter
                </button>
            </div>

            <div data-testid="t-dummy-site-div-1752672977568-67">
                <h3 data-testid="t-dummy-site-h3-1752672977568-26">State Variants</h3>
                <button
                    class="btn btn-primary active"
                    data-testid="t-dummy-site-button-1752672977568-58"
                >
                    Active
                </button>
                <button
                    class="btn btn-primary"
                    disabled
                    data-testid="t-dummy-site-button-1752672977568-59"
                >
                    Disabled
                </button>
                <button
                    class="btn btn-primary not-clickable"
                    data-testid="t-dummy-site-button-1752672977568-60"
                >
                    Not Clickable
                </button>
            </div>
        </div>

        <div
            style="position: relative; height: 100px"
            data-testid="t-dummy-site-div-1752672977568-69"
        >
            <h3 data-testid="t-dummy-site-h3-1752672977568-27">Special Classes</h3>

            <strong data-testid="t-dummy-site-strong-1752672977568-1">floating--button (with action--btn and btn-sm)</strong>
            <button
                class="btn btn-primary action--btn btn-sm floating--button"
                data-testid="t-dummy-site-button-1752672977568-61"
            >
                +
            </button>
        </div>

        <h3 data-testid="t-dummy-site-h3-1752672977568-28">Inputs, Radios, Checkboxen</h3>

        <div
            class="content-box"
            data-testid="t-dummy-site-div-1752672977568-73"
        >
            <div
                class="form-elements--wrapper"
                data-testid="t-dummy-site-div-1752672977568-72"
            >
                <div
                    class="mb-3"
                    data-testid="t-dummy-site-div-1752672977568-70"
                >
                    <label
                        for="exampleFormControlInput1"
                        class="form-label"
                        data-testid="t-dummy-site-label-1752672977568-1"
                        >Email address</label
                    >
                    <input
                        type="email"
                        class="form-control"
                        id="exampleFormControlInput1"
                        placeholder="name@example.com"
                        data-testid="t-dummy-site-input-1752672977568-1"
                    />
                </div>
                <div data-testid="t-dummy-site-div-1752672977568-71">
                    <label
                        for="exampleFormControlTextarea1"
                        class="form-label"
                        data-testid="t-dummy-site-label-1752672977568-2"
                        >Example textarea</label
                    >
                    <textarea
                        class="form-control"
                        id="exampleFormControlTextarea1"
                        rows="3"
                        data-testid="t-dummy-site-textarea-1752672977568-1"
                    ></textarea>
                </div>
            </div>
        </div>

        <input
            class="form-control form-control-lg my-3"
            type="text"
            placeholder=".form-control-lg"
            aria-label=".form-control-lg example"
            data-testid="t-dummy-site-input-1752672977568-2"
        />
        <input
            class="form-control my-3"
            type="text"
            placeholder="Default input"
            aria-label="default input example"
            data-testid="t-dummy-site-input-1752672977568-3"
        />
        <input
            class="form-control form-control-sm my-3"
            type="text"
            placeholder=".form-control-sm"
            aria-label=".form-control-sm example"
            data-testid="t-dummy-site-input-1752672977568-4"
        />

        <div
            class="row"
            data-testid="t-dummy-site-div-1752672977568-80"
        >
            <div
                class="col-auto"
                data-testid="t-dummy-site-div-1752672977568-76"
            >
                <div
                    class="form-check"
                    data-testid="t-dummy-site-div-1752672977568-74"
                >
                    <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                        data-testid="t-dummy-site-input-1752672977568-5"
                    />
                    <label
                        class="form-check-label"
                        for="flexCheckDefault"
                        data-testid="t-dummy-site-label-1752672977568-3"
                    >
                        Default checkbox
                    </label>
                </div>
                <div
                    class="form-check"
                    data-testid="t-dummy-site-div-1752672977568-75"
                >
                    <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                        checked
                        data-testid="t-dummy-site-input-1752672977568-6"
                    />
                    <label
                        class="form-check-label"
                        for="flexCheckChecked"
                        data-testid="t-dummy-site-label-1752672977568-4"
                    >
                        Checked checkbox
                    </label>
                </div>
            </div>
            <div
                class="col-auto"
                data-testid="t-dummy-site-div-1752672977568-79"
            >
                <div
                    class="form-check"
                    data-testid="t-dummy-site-div-1752672977568-77"
                >
                    <input
                        class="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="flexRadioDefault1"
                        data-testid="t-dummy-site-input-1752672977568-7"
                    />
                    <label
                        class="form-check-label"
                        for="flexRadioDefault1"
                        data-testid="t-dummy-site-label-1752672977568-5"
                    >
                        Default radio
                    </label>
                </div>
                <div
                    class="form-check"
                    data-testid="t-dummy-site-div-1752672977568-78"
                >
                    <input
                        class="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="flexRadioDefault2"
                        checked
                        data-testid="t-dummy-site-input-1752672977568-8"
                    />
                    <label
                        class="form-check-label"
                        for="flexRadioDefault2"
                        data-testid="t-dummy-site-label-1752672977568-6"
                    >
                        Default checked radio
                    </label>
                </div>
            </div>
        </div>

        <div
            class="row"
            data-testid="t-dummy-site-div-1752672977568-83"
        >
            <div
                class="col-auto"
                data-testid="t-dummy-site-div-1752672977568-81"
            >
                <label
                    class="form-check checkbox-big"
                    data-testid="t-dummy-site-label-1752672977568-8"
                >
                    <input
                        type="radio"
                        id="bigCheckDummy"
                        name="bigCheckDummy"
                        class="form-check-input"
                        data-testid="t-dummy-site-input-1752672977568-9"
                    />
                    <label
                        for="bigCheckDummy"
                        class="form-check-label"
                        data-testid="t-dummy-site-label-1752672977568-7"
                        >Checkbox Big</label
                    >
                </label>
            </div>
            <div
                class="col-auto"
                data-testid="t-dummy-site-div-1752672977568-82"
            >
                <label
                    class="form-check checkbox-big"
                    data-testid="t-dummy-site-label-1752672977568-10"
                >
                    <input
                        type="checkbox"
                        id="bigRadioDummy"
                        name="bigRadioDummy"
                        class="form-check-input"
                        data-testid="t-dummy-site-input-1752672977568-10"
                    />
                    <label
                        for="bigRadioDummy"
                        class="form-check-label"
                        data-testid="t-dummy-site-label-1752672977568-9"
                        >Radio Big</label
                    >
                </label>
            </div>
        </div>

        <div
            class="row"
            data-testid="t-dummy-site-div-1752672977568-88"
        >
            <div
                class="col-auto"
                data-testid="t-dummy-site-div-1752672977568-84"
            >
                <select
                    class="form-select form-select-lg mb-3"
                    aria-label="Large select example"
                    data-testid="t-dummy-site-select-1752672977568-1"
                >
                    <option
                        selected
                        data-testid="t-dummy-site-option-1752672977568-1"
                    >
                        Open this select menu
                    </option>
                    <option
                        value="1"
                        data-testid="t-dummy-site-option-1752672977568-2"
                    >
                        One
                    </option>
                    <option
                        value="2"
                        data-testid="t-dummy-site-option-1752672977568-3"
                    >
                        Two
                    </option>
                    <option
                        value="3"
                        data-testid="t-dummy-site-option-1752672977568-4"
                    >
                        Three
                    </option>
                </select>
            </div>
            <div
                class="col-auto"
                data-testid="t-dummy-site-div-1752672977568-85"
            >
                <select
                    class="form-select form-select-sm"
                    aria-label="Small select example"
                    data-testid="t-dummy-site-select-1752672977568-2"
                >
                    <option
                        selected
                        data-testid="t-dummy-site-option-1752672977568-5"
                    >
                        Open this select menu
                    </option>
                    <option
                        value="1"
                        data-testid="t-dummy-site-option-1752672977568-6"
                    >
                        One
                    </option>
                    <option
                        value="2"
                        data-testid="t-dummy-site-option-1752672977568-7"
                    >
                        Two
                    </option>
                    <option
                        value="3"
                        data-testid="t-dummy-site-option-1752672977568-8"
                    >
                        Three
                    </option>
                </select>
            </div>
            <div
                class="col-auto"
                data-testid="t-dummy-site-div-1752672977568-87"
            >
                <div
                    class="form-select-wrapper form-select-wrapper-lg mt-auto"
                    data-testid="t-dummy-site-div-1752672977568-86"
                >
                    <select
                        class="form-select"
                        data-testid="t-dummy-site-select-1752672977568-3"
                    >
                        <option
                            value="1"
                            data-testid="t-dummy-site-option-1752672977568-9"
                        >
                            Test 1
                        </option>
                        <option
                            value="2"
                            data-testid="t-dummy-site-option-1752672977568-10"
                        >
                            Test 2
                        </option>
                    </select>
                    <span
                        class="option-label"
                        data-testid="t-dummy-site-span-1752672977568-3"
                        >Label</span
                    >
                </div>
            </div>
        </div>

        <div
            class="row align-items-end g-3"
            data-testid="t-dummy-site-div-1752672977568-118"
        >
            <div
                class="col-auto"
                data-testid="t-dummy-site-div-1752672977568-93"
            >
                <div
                    class="form-group mt-3"
                    data-testid="t-dummy-site-div-1752672977568-92"
                >
                    <label
                        class="form-label"
                        data-testid="t-dummy-site-label-1752672977568-11"
                    ></label>
                    <div
                        class="input-group input-group-sm"
                        data-testid="t-dummy-site-div-1752672977568-91"
                    >
                        <input
                            class="form-control"
                            id="cleaningWastePercent"
                            type="number"
                            data-testid="t-dummy-site-input-1752672977568-11"
                        />
                        <div
                            class="input-group-append"
                            data-testid="t-dummy-site-div-1752672977568-90"
                        >
                            <div
                                class="input-group-text"
                                data-testid="t-dummy-site-div-1752672977568-89"
                            ></div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="col-auto"
                data-testid="t-dummy-site-div-1752672977568-97"
            >
                <div
                    class="input-group"
                    data-testid="t-dummy-site-div-1752672977568-96"
                >
                    <input
                        type="number"
                        class="form-control"
                        id="conditionValue"
                        placeholder="z.B. 300"
                        data-testid="t-dummy-site-input-1752672977568-12"
                    />
                    <div
                        class="input-group-append"
                        data-testid="t-dummy-site-div-1752672977568-95"
                    >
                        <div
                            class="input-group-text"
                            data-testid="t-dummy-site-div-1752672977568-94"
                        >
                            <span data-testid="t-dummy-site-span-1752672977568-4">€</span>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="col-auto"
                data-testid="t-dummy-site-div-1752672977568-101"
            >
                <div
                    class="input-box"
                    data-testid="t-dummy-site-div-1752672977568-100"
                >
                    <label
                        class=""
                        data-testid="t-dummy-site-label-1752672977568-12"
                        >Label</label
                    >

                    <div
                        class="input-group input-group-lg"
                        data-testid="t-dummy-site-div-1752672977568-99"
                    >
                        <input
                            style="max-width: none"
                            class="text-center form-control"
                            type="number"
                            min="1"
                            step="1"
                            data-testid="t-dummy-site-input-1752672977568-13"
                        />
                        <div
                            class="bg-primary-light text-white input-group input-group-append"
                            data-testid="t-dummy-site-div-1752672977568-98"
                        >
                            <span
                                class="input-group-text"
                                data-testid="t-dummy-site-span-1752672977568-5"
                                >Test</span
                            >
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="col-auto"
                data-testid="t-dummy-site-div-1752672977568-109"
            >
                <div
                    class="mini--box"
                    data-testid="t-dummy-site-div-1752672977568-108"
                >
                    <div
                        class="mb--header"
                        data-testid="t-dummy-site-div-1752672977568-102"
                    ></div>
                    <div
                        class="mb--text"
                        data-testid="t-dummy-site-div-1752672977568-107"
                    >
                        <div
                            class="form-group"
                            data-testid="t-dummy-site-div-1752672977568-106"
                        >
                            <div
                                class="input-group"
                                data-testid="t-dummy-site-div-1752672977568-105"
                            >
                                <input
                                    type="number"
                                    placeholder="0"
                                    value=""
                                    min="0"
                                    class="form-control"
                                    data-testid="t-dummy-site-input-1752672977568-14"
                                />
                                <div
                                    class="input-group-append"
                                    data-testid="t-dummy-site-div-1752672977568-104"
                                >
                                    <div
                                        class="input-group-text"
                                        data-testid="t-dummy-site-div-1752672977568-103"
                                    >
                                        Liter
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="col-auto"
                data-testid="t-dummy-site-div-1752672977568-117"
            >
                <div
                    class="mini--box type-2"
                    data-testid="t-dummy-site-div-1752672977568-116"
                >
                    <div
                        class="mb--header"
                        data-testid="t-dummy-site-div-1752672977568-110"
                    ></div>
                    <div
                        class="mb--text"
                        data-testid="t-dummy-site-div-1752672977568-115"
                    >
                        <div
                            class="form-group"
                            data-testid="t-dummy-site-div-1752672977568-114"
                        >
                            <div
                                class="input-group"
                                data-testid="t-dummy-site-div-1752672977568-113"
                            >
                                <input
                                    type="number"
                                    placeholder="-"
                                    value=""
                                    [disabled]="true"
                                    class="form-control"
                                    data-testid="t-dummy-site-input-1752672977568-15"
                                />
                                <div
                                    class="input-group-append"
                                    data-testid="t-dummy-site-div-1752672977568-112"
                                >
                                    <div
                                        class="input-group-text"
                                        data-testid="t-dummy-site-div-1752672977568-111"
                                    >
                                        KG
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="button-wrapper"
            data-testid="t-dummy-site-div-1752672977568-119"
        >
            <button
                type="button"
                class="btn btn-danger"
                data-testid="t-dummy-site-button-1752672977568-62"
            >
                <i
                    class="oc-general-cancel"
                    data-testid="t-dummy-site-i-1752672977568-13"
                ></i>
            </button>
            <button
                type="button"
                class="btn btn-success"
                data-testid="t-dummy-site-button-1752672977568-63"
            >
                <i
                    class="oc-general-check"
                    data-testid="t-dummy-site-i-1752672977568-14"
                ></i>
            </button>
        </div>
    </section>
</div>
